class IconManager {

    constructor() {
        this.iconPath = '/fe-web/img/donnad/icons';
        this.icons = [];
        this.processIcons(document).then(() => console.log('icon processed'));
    }


    processIconAsync(element) {
        this.processIcons(element).then(() => console.log('async icon processed'));
    }


    getIcon(iconName) {
        return this.icons[iconName] || null;
    }

    addIcon(iconName, icon) {
        this.icons[iconName] = icon;
    }

    async loadIcon(iconName, size = "regular", color = null, clazz = null) {
        const iconPath = `${this.iconPath}/${iconName}.svg`;
        try {
            const response = await fetch(iconPath);
            if (!response.ok) {
                throw new Error(`Impossibile caricare l'icona: ${iconPath}`);
            }
            const iconContent = await response.text();
            const cl = `${clazz ? clazz : ""} ${size} ${color ? color : ""}`;
            const wrappedIcon = `<span class="${cl}">${iconContent}</span>`;
            this.addIcon(iconName, wrappedIcon);
            return wrappedIcon;
        } catch (error) {
            console.error(`Errore nel caricamento dell'icona ${iconName}:`, error);
        }
    }

    async processIcons(element) {
        // Trova tutti i tag <icon-component />
        const iconComponents = element.querySelectorAll("icontemplate");

        // Itera su tutti gli <icon-component /> trovati
        for (const iconComponent of iconComponents) {
            const iconName = iconComponent.getAttribute("icon");
            const size = iconComponent.getAttribute("size");
            const color = iconComponent.getAttribute("color");
            const clazz = iconComponent.getAttribute("clazz");

            if (!iconName) {
                console.warn("Nessun nome icona trovato nell'attributo 'icon'");
                continue;
            }

            // Carica l'icona con i parametri trovati
            const iconHtml = await this.loadIcon(iconName, size, color, clazz);

            // Sostituisci il tag <icon-component /> con l'HTML dell'icona
            const parent = iconComponent.parentNode;
            if (parent) {
                const iconFragment = document.createRange().createContextualFragment(iconHtml);
                parent.replaceChild(iconFragment, iconComponent);
            }
        }
    }
}

export default IconManager;
